import { FC } from 'react'
import { Cover, Stack, Button } from 'design-system'

import { useRouter } from 'src/lib/router'

import { ContractExpiredAdminView } from './admin-view'
import { ContractExpiredMemberView } from './member-view'
import { ContractExpiredBlockerProps } from './types'

export const ContractExpiredView: FC<ContractExpiredBlockerProps> = ({
  role
}) => {
  const router = useRouter()
  // The role comes off the wire from the backend anomaly; only network admins
  // get distinct copy — every other value (member, facilitator, or anything
  // unrecognized) gets the shared member copy.
  const isNetworkAdmin = role === 'network-admin'
  const headline = isNetworkAdmin
    ? 'This organization’s access has ended'
    : 'Your communities aren’t available right now'
  const RoleView = isNetworkAdmin
    ? ContractExpiredAdminView
    : ContractExpiredMemberView

  return (
    <Cover fullSize className="h-screen">
      <Stack
        className="w-11/12 max-w-2xl overflow-y-auto rounded-lg bg-white p-6 text-center"
        gap={2}>
        <div className="mx-auto h-auto w-full pb-4">
          <h3 className="py-4">{headline}</h3>
          <RoleView />
          <div className="text-left text-slate-500">
            For additional help please email us at{' '}
            <a href="mailto:support@yellowdig.com">support@yellowdig.com</a>
          </div>
        </div>
        <div className="flex flex-col gap-y-4 md:flex-row md:justify-center md:gap-x-4">
          <Button
            buttonSize="xs"
            buttonType="primary"
            fullWidth
            onClick={() => {
              router.push('/user/find-organization')
            }}>
            Go Home
          </Button>
        </div>
      </Stack>
    </Cover>
  )
}
